import React from 'react';
import Breadcrumb from '../../../core/layout/Breadcrumb';
import ContractDetailContainer from './ContractDetailContainer';
import DowngradeContractFormContainer from './DowngradeContractFormContainer';
import Separator from '../../../core/layout/Separator';
import DowngradeContractProductsModalContainer from './DowngradeContractProductsModalContainer';

const DowngradeContractFormScene = (props) => (
  <>
    <Breadcrumb
      crumbs={[
        ...(props.location.state && props.location.state.from
          ? [{ text: props.location.state.from.text, link: props.location.state.from.pathname }]
          : []),
        {
          text: 'Downgrade Contract',
        },
      ]}
    />
    <ContractDetailContainer contractId={props.params.contractId} />
    <Separator />
    <DowngradeContractFormContainer contractId={props.params.contractId} />
    <DowngradeContractProductsModalContainer />
  </>
);

export default DowngradeContractFormScene;
